import { RxWebSocketStatus } from 'messaging'
import { AuthorisedUser } from 'api'

export enum ConnectionStatus {
  Disconnected = 'Disconnected',
  Connected = 'Connected',
  LoggedIn = 'LoggedIn'
}

export enum CredentialsStatus {
  NotSet = 'NotSet',
  Available = 'Available'
}

export interface ConnectionStore {
  credentialsStatus: CredentialsStatus
  socketStatus: RxWebSocketStatus[]
  connectionStatus: ConnectionStatus
  connectedOnce: boolean
  loggedInOnce: boolean
  lastUsername: string | null
  lastErrorMessage: string | null
  lastSocketErrorMessage: string | null
  loginCorrelationId: string | null
  authorisedUser: AuthorisedUser | null
}
